import {View, StyleSheet, Image, Dimensions, Platform} from 'react-native';
import Styles from '../../Styles';
import Localized from 'src/constants/AppStrings';
import AVText from '../../elements/AVText';
import CartTypes from 'src/constants/cart/CartTypes';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {scanAndPayTemplate} from 'src/components/screens/scanAndPay/templates/scanandPayThemeHelper';
import {getDescriber} from 'src/components/screens/orderAhead/descriptor/DescriptorType';
import {LocationType} from 'src/types/Location';
import RecentComboIcon from 'src/components/img/svg/RecentComboIcon';
const {width: screenWidth, height: screenHeight} = Dimensions.get('window');
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import Settings from 'src/Settings';
import EmptyOrderIcon from 'src/components/img/svg/EmptyOrdersIcon';

const {bodyFontSize, mainFontFamily, subHeaderFontSize, bodyLargeFontSize} =
  getLayoutDescriber();

type ListCartEmptyProps = {
  cartType: CartTypes;
  showCustomText?: boolean;
  handleGoBack?: () => void;
  location?: LocationType;
};

const ListCartEmpty = (props: ListCartEmptyProps) => {
  const {top} = useSafeAreaInsets();
  const localData = props.showCustomText
    ? 'barcode_refocus_and_find_non_barcoded_items_revolve'
    : 'barcode_refocus_and_find_non_barcoded_items';
  if (props.cartType == CartTypes.ScanAndPay) {
    return (
      <View style={styles.container}>
        {props.showCustomText && (
          <AVText
            accessible={true}
            accessibilityLabel={Localized.Labels[localData]}
            aria-label={Localized.Labels[localData]}
            style={[styles.labelLocation]}
          >
            {props.location.displayName
              ? props.location.displayName
              : props.location.name}
          </AVText>
        )}

        <AVText
          accessible={true}
          accessibilityLabel={Localized.Labels[localData]}
          aria-label={Localized.Labels[localData]}
          style={[styles.label, getDescriber().getEmptyCartlblStyle()]}
        >
          {Localized.Labels[localData]}
        </AVText>
        <View style={styles.scanProductImageView}>
          <Image
            style={[styles.scanProductImage]}
            resizeMode={'contain'}
            source={scanAndPayTemplate.emptyCartImage}
          />
        </View>
      </View>
    );
  } else {
    return (
      <View style={styles.orderAheadEmptycontainer}>
        <AVText
          accessible={true}
          accessibilityLabel={Localized.Labels.orderAheadEmptyCart}
          aria-label={Localized.Labels.orderAheadEmptyCart}
          style={styles.orderAheadLabel}
        >
          {Localized.Labels.orderAheadEmptyCart}
        </AVText>
        <View style={styles.emptyIconView}>
          {Settings.isAramark() ? (
            <EmptyOrderIcon />
          ) : (
            <RecentComboIcon
              fillColor={scanAndPayTemplate.emptyCartColors.primaryFill}
              secondaryColor={scanAndPayTemplate.emptyCartColors.secondaryFill}
            />
          )}
        </View>
        <RoundedAppButton
          buttonContainerStyle={styles.btnContainer}
          onPress={props.handleGoBack}
          buttonType={RoundedAppButtonType.Outline}
          buttonViewStyle={{
            width: 319,
            height: 42,
            backgroundColor: Styles.white,
          }}
          testID={'qa_BackToMenu_btn'}
          textStyle={{fontSize: bodyFontSize()}}
          accessibilityLabelValue={Localized.Buttons.goback_to_menu}
          aria-label={Localized.Buttons.goback_to_menu}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
          titleText={Localized.Buttons.goback_to_menu}
        />
      </View>
    );
  }
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: Styles.Spacing.m3,
  },
  orderAheadEmptycontainer: {
    flex: 1,
    justifyContent: 'center',
    marginHorizontal: Styles.Spacing.m3,
  },
  scanProductImage: {
    width: Dimensions.get('screen').width - 16,
    height: Dimensions.get('screen').width / 2.1,
    resizeMode: 'cover',
  },
  scanProductImageView: {
    flex: 1,
    justifyContent: 'flex-end',
    position: 'absolute',
    bottom: -2,
    left: -20,
    width: Dimensions.get('screen').width,
  },
  orderAheadEmptyImage: {
    marginTop: Styles.Spacing.m3 + Styles.Spacing.m2,
    alignSelf: 'center',
  },
  label: {
    marginTop: Styles.Spacing.m3,
    fontFamily: mainFontFamily(),
    fontSize: bodyFontSize(),
    textAlign: 'center',
  },
  orderAheadLabel: {
    marginTop: Styles.Spacing.m3,
    fontFamily: mainFontFamily(),
    fontSize: subHeaderFontSize(),
    fontWeight: 'bold',
    textAlign: 'center',
  },
  labelLocation: {
    marginTop: Styles.Spacing.m3,
    fontFamily: mainFontFamily(),
    fontSize: bodyLargeFontSize(),
    fontWeight: '700',
    color: '#111',
  },
  emptyIconView: {
    alignSelf: 'center',
    marginTop: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  btnContainer: {
    marginTop: Styles.Spacing.m4 + Styles.Spacing.m3,
    alignSelf: 'center',
  },
});

export default ListCartEmpty;
